import TopicMemberRequestContainer from '../../containers/TopicMemberRequestContainer';

const MemberRequestCard = () => (
  <div className="grid grid--full grid--center">
    <div className="grid__item two-thirds palm--one-whole">
      <div className="bg-white bordered palm--border-none soft">
        <div className="text--center">
          <TopicMemberRequestContainer />
        </div>
      </div>
    </div>
  </div>
);

export default MemberRequestCard;
